<div class="container vh-100 d-flex justify-content-center align-items-center">

  <div class="row w-100 justify-content-end">
 <div class="card shadow-lg border-0 rounded-4 overflow-hidden animate__animated animate__fadeIn cardTop col-md-4" style="max-width:400px" >
    <div class="row g-0">

      <!-- Login Form -->
<div class="col-md-12 p-md-5 pb-md-4 p-4 pb-3">
          <div class="text-center mb-4 mt-2">
          <img src="/public/public/img/dhs/DHSCareLogo.png" alt="DHS Logo"  style=" height: 55px;    width: auto;   margin-bottom:0px !important;
"/>
        </div>
        <h6 class="loginTitle text-center mb-0 pb-2">LOGIN TO YOUR ACCOUNT</h6>
        <!-- Angular form -->
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm" novalidate>

          <!-- Alerts -->
          <div *ngIf="message" class="form-group has-error">
            <div class="col-sm-12">
              <div class="alert reduce-padding pb-2">{{this.message}}</div>
            </div>
          </div>

          <!-- Username input -->
          <div class="mb-3 input-group InputHeight GreenBoxShadow">
            <span class="input-group-text bg-white border-end-0"><i class="bx bx-user"></i></span>
            <input name="username" required type="text" id="username_id" title="Username"
              class="form-control border-start-0" placeholder="Username" [(ngModel)]="loginData.username"
              #username="ngModel" />
          </div>

          <!-- Password input -->
          <div class="mb-3 input-group InputHeight GreenBoxShadow">
            <span class="input-group-text bg-white border-end-0"><i class="bx bx-lock"></i></span>
            <input name="password" required type="password" id="password" title="Password"
              class="form-control border-start-0" placeholder="Password" [(ngModel)]="loginData.password"
              #password="ngModel" />
          </div>

          <!-- Submit button -->
          <button id="login" type="submit" class="btn LoginBtn w-100 InputHeight"
            [disabled]="isConnecting || (loginForm.invalid && loginForm.touched)">
            <i class="bi bi-box-arrow-in-right me-2"></i> Log In
          </button>

          <!-- Version info -->
          <p class="text-center mt-3 small text-muted CopyText">
            &copy; Copyright 2025 <span class="GreenLink">DHS-HIS</span>. All Rights Reserved.
          </p>
        </form>
      </div>

      <!-- Right Content -->
     <!-- <div    class="col-md-6 d-none  flex-column justify-content-center align-items-center bg-white p-4 text-center d-none">
        <h5 class="fw-bold">
          Welcome to <span class="GreenColor">DHS</span>-<span class="OrangeColor">HIS</span>
        </h5>
        <p class="text-muted small mt-2 SubPara">
          A Complete Healthcare Management Solution for Hospitals, Clinics and Pharmacy.
        </p>
      </div>-->

    </div>
  </div>
</div>

  </div>

<!--Login div-->
<div class="clear"></div>

<script type="text/javascript" src="/public/themes/theme-default/login/js/jquery.min.js"></script>
<script type="text/javascript" src="/public/themes/theme-default/login/components/effect/jquery-jrumble.js"></script>
<script type="text/javascript" src="/public/themes/theme-default/login/components/ui/jquery.ui.min.js"></script>
<script type="text/javascript" src="/public/themes/theme-default/login/components/tipsy/jquery.tipsy.js"></script>
<script type="text/javascript" src="/public/themes/theme-default/login/components/checkboxes/iphone.check.js"></script>
<script type="text/javascript" src="/public/themes/theme-default/login/js/login.js"></script>
